import React from 'react';
import { Button, Col, Form, Space, message } from 'antd';
import { BookyInput, InputType } from '../../Forms/BookyInput';
import { BookySelectDropDown } from '../../Forms/BookySelectDropDown';
import { OneFrontDatePicker } from '../../Forms/BookyDatePicker';
import { BookyButton } from '../../Buttons/BookyButton';
import { TextService } from '../../../Services/TextService';
import { MemberService } from '../../../Services/MemberService';
import { getLastThreeYearAsOptions } from '../../../Helpers/PaymentYearOptions';
import { getPreviousYear } from '../../../Helpers/DateHelpers';

interface AddManualPaymentProps {
    memberId: number;
    onPaymentSaved: () => void;
    onCancel?: () => void;
}

const AddManualPayment = ({ memberId, onPaymentSaved, onCancel }: AddManualPaymentProps) => {
    const [form] = Form.useForm();
    const GetText = TextService.GetText;

    const handleSave = async () => {
        try {
            await MemberService.SaveOrUpdatePayment({
                memberId: memberId,
                year: form.getFieldValue("year").toString(),
                paymentDate: new Date(form.getFieldValue("paymentDate").format('YYYY-MM-DD')),
                amount: form.getFieldValue("amount"),
            });
            form.resetFields();
            onPaymentSaved();
        } catch {
            message.warning(GetText("EditMember_ErrorSaving"));
        }
    };

    return (
        <div style={{ marginTop: '8px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <h4 style={{ margin: 0 }}>{GetText("ManagePayments_AddManualTitle")}</h4>
                {onCancel && (
                    <Button type="link" size="small" onClick={onCancel}>
                        {GetText("AddPaymentLink_CollapseForm")}
                    </Button>
                )}
            </div>
            <Form form={form} colon={false} labelAlign="left" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}
                initialValues={{ year: getPreviousYear(0) }}
            >
                <Col span={17}>
                    <BookyInput type={InputType.number} label={GetText("AddPayment_NoteColumnPlaceHolder")} onClick={handleSave} name="amount" req placeholder={GetText("AddPayment_NoteColumnPlaceHolder")} />
                    <BookySelectDropDown label={GetText("AddPayment_YearColumn")} name="year" options={getLastThreeYearAsOptions()} />
                    <OneFrontDatePicker label={GetText("AddPayment_PaymentDateColumn")} name="paymentDate" placeholder={GetText("AddPayment_PaymentDatePlaceHolder")} />
                    <Form.Item label={" "}>
                        <BookyButton type="primary" fullWidth={false} text={GetText("AddPayment_SaveNote")} onClick={handleSave} />
                    </Form.Item>
                </Col>
            </Form>
        </div>
    );
};

export { AddManualPayment };
export default AddManualPayment;
